import { uniq } from "lodash";
import { GQLConsequencesBlock, TradeoffBlock } from "../../../../utils/types";

export type AttendeeThreadHeader = { names: string[]; hasCurrentUser: boolean };

export const removeTradeoffsEventsAlsoInConsequences = ({
  tradeoffThreadItemsAll,
  yourCalDiffs,
  otherCalDiffs,
}: {
  tradeoffThreadItemsAll: TradeoffBlock[];
  yourCalDiffs: {
    eventId: string;
  }[];
  otherCalDiffs: {
    eventId: string;
  }[];
}) => {
  const consequenceIds = [
    ...yourCalDiffs.map((diff) => diff.eventId),
    ...otherCalDiffs.map((diff) => diff.eventId),
  ];
  const newTradeoffBlocks: TradeoffBlock[] = [];
  for (const block of tradeoffThreadItemsAll) {
    const blockWithoutConsequenceItems = block.schedulingTradeoffs.filter(
      (tradeoff) => !consequenceIds.includes(tradeoff?.externalEventId || ""),
    );
    if (blockWithoutConsequenceItems.length) {
      newTradeoffBlocks.push({
        ...block,
        schedulingTradeoffs: blockWithoutConsequenceItems,
      });
    }
  }

  return newTradeoffBlocks;
};

export const getConsequencesNamesForHeader = (
  consequencesBlock: GQLConsequencesBlock | null,
): AttendeeThreadHeader => {
  if (!consequencesBlock) return { names: [], hasCurrentUser: false };

  const headerInfo: AttendeeThreadHeader = {
    names: [],
    hasCurrentUser: false,
  };

  if (consequencesBlock.yourCalDiffs?.length) {
    headerInfo.hasCurrentUser = true;
    headerInfo.names.push("You");
  }

  const consequenceAttendees = uniq(
    consequencesBlock?.otherCalDiffs
      ?.map((consequenceDiff) => consequenceDiff.affectedAttendees)
      .flat(),
  );

  for (const attendee of consequenceAttendees) {
    headerInfo.names.push(attendee.person?.profile?.givenName || attendee.calendarId);
  }

  return headerInfo;
};

export const getTradeoffNamesForHeader = (
  tradeoffThreadItems: {
    aggregateAttendees: {
      isYou: boolean;
      primaryCalendarId: string;
      profile: {
        familyName: string | null;
        givenName: string | null;
        externalImageUrl: string | null;
      } | null;
    }[];
  }[],
): AttendeeThreadHeader => {
  const headerInfo: AttendeeThreadHeader = {
    names: [],
    hasCurrentUser: false,
  };

  const tradeoffThreadItemAttendees = uniq(
    tradeoffThreadItems.map((tradeoffBlock) => tradeoffBlock.aggregateAttendees).flat(),
  );

  for (const attendee of tradeoffThreadItemAttendees) {
    if (attendee.isYou) {
      headerInfo.hasCurrentUser = true;
      headerInfo.names.push("You");
    } else {
      headerInfo.names.push(attendee?.profile?.givenName || attendee.primaryCalendarId);
    }
  }

  return headerInfo;
};
